// src/calculators/personPick.js — „Получател на дохода (лице от „Досиета")"
// в калкулаторите. Изнесено от chl55.js (ПРОМТ-21), за да го ползва и
// „Граждански договор" БЕЗ копие: изборът е от досиетата на активната фирма,
// „+ ново лице" пише името на място, а досието се създава чак при печат или
// запис (ensureId) — не при всяко натискане на клавиш.

import { el, field, input } from '../shared/dom.js';
import { api } from '../shared/api.js';
import { state, cq } from '../shared/state.js';

const NEW_PERSON = '__new__';

export function personPicker(onChange) {
  let persons = [];
  const changed = () => { if (onChange) onChange(); };
  const sel = el('select', {}, el('option', { value: '', text: '— по избор —' }));
  const nameInput = input({ value: '', placeholder: 'Иван Петров Иванов' });
  const nameField = field('Име на новото лице', nameInput);
  nameField.style.display = 'none';

  async function load() {
    try { persons = await api('/dossiers' + cq()); } catch (e) { persons = []; }
    sel.innerHTML = '';
    sel.appendChild(el('option', { value: '', text: '— по избор —' }));
    persons.forEach((p) => sel.appendChild(el('option', { value: p.id, text: p.full_name })));
    sel.appendChild(el('option', { value: NEW_PERSON, text: '+ ново лице' }));
    changed();
  }
  function name() {
    if (sel.value === NEW_PERSON) return nameInput.value.trim();
    const p = persons.find((x) => String(x.id) === String(sel.value));
    return p ? p.full_name : '';
  }
  sel.addEventListener('change', () => { nameField.style.display = sel.value === NEW_PERSON ? '' : 'none'; changed(); });
  nameInput.addEventListener('input', changed);

  // Ако е ново име — първо се създава досието, после се ползва номерът му.
  async function ensureId() {
    if (sel.value && sel.value !== NEW_PERSON) return Number(sel.value);
    if (sel.value === NEW_PERSON && nameInput.value.trim()) {
      const p = await api('/dossiers', { method: 'POST', body: JSON.stringify({ company_id: state().activeCompany, full_name: nameInput.value.trim() }) });
      persons.push(p);
      sel.insertBefore(el('option', { value: p.id, text: p.full_name, selected: true }), sel.lastChild);
      nameField.style.display = 'none';
      return p.id;
    }
    return null;
  }

  return { sel, nameField, load, name, ensureId };
}
